module.exports = __webpack_public_path__ + "img/forAn.21b4ef01.gif";